export default "__VITE_ASSET__dFayGZrs__"